import { defineMessages } from 'react-intl';

/** The copy of the first open, the make flow and the plan gates (design music-video e1 to e6). */
export const stateMessages = defineMessages({
  opening: { id: 'app.sml.musicVideo.state.opening', defaultMessage: 'Opening the editor' },
  firstFailed: {
    id: 'app.sml.musicVideo.state.firstFailed',
    defaultMessage: 'We could not start the first cut. Try again.',
  },
  cutLimit: {
    id: 'app.sml.musicVideo.state.cutLimit',
    defaultMessage: 'This song has {count} cuts, the most it can hold. Open a cut and change it.',
  },

  // e1: the director makes the first cut
  directorTitle: { id: 'app.sml.musicVideo.director.title', defaultMessage: 'Making the first cut of {title}' },
  directorText: {
    id: 'app.sml.musicVideo.director.text',
    defaultMessage: 'About 30 seconds. It costs no credits. You can change every cut after.',
  },
  stepRead: { id: 'app.sml.musicVideo.director.stepRead', defaultMessage: 'Reading the song' },
  stepReadFacts: {
    id: 'app.sml.musicVideo.director.stepReadFacts',
    defaultMessage: '{sections, plural, one {# section} other {# sections}} · {bpm} BPM',
  },
  stepPick: { id: 'app.sml.musicVideo.director.stepPick', defaultMessage: 'Picking clips for each section' },
  stepCut: { id: 'app.sml.musicVideo.director.stepCut', defaultMessage: 'Cutting on the beat' },
  stepText: { id: 'app.sml.musicVideo.director.stepText', defaultMessage: 'Adding the lyrics and the end card' },
  directorUsesOwn: {
    id: 'app.sml.musicVideo.director.usesOwn',
    defaultMessage: 'Uses your {count, plural, one {# clip} other {# clips}} of this song and the clip bank.',
  },
  directorUsesBank: { id: 'app.sml.musicVideo.director.usesBank', defaultMessage: 'Uses the clip bank.' },
  directorFailed: {
    id: 'app.sml.musicVideo.director.failed',
    defaultMessage: 'The AI could not plan this cut. You got a simple cut; try Recut later.',
  },
  recutWorking: {
    id: 'app.sml.musicVideo.director.recutWorking',
    defaultMessage: 'The AI recuts this cut. You can edit again when it is done.',
  },
  dismiss: { id: 'app.sml.musicVideo.state.dismiss', defaultMessage: 'Close' },

  // e6: no master
  noMasterTitle: { id: 'app.sml.musicVideo.noMaster.title', defaultMessage: 'Add the song file first' },
  noMasterText: {
    id: 'app.sml.musicVideo.noMaster.text',
    defaultMessage:
      'The editor cuts on the beat of the master. Add the WAV, FLAC or MP3 of {title}. We keep it on the song for every asset.',
  },
  noMasterWaiting: {
    id: 'app.sml.musicVideo.noMaster.waiting',
    defaultMessage: 'Did you add it already? Then we still read it. The editor opens when it is ready.',
  },
  noMasterAdd: { id: 'app.sml.musicVideo.noMaster.add', defaultMessage: 'Add the song file' },
  noMasterBack: { id: 'app.sml.musicVideo.noMaster.back', defaultMessage: 'Back' },

  // e2: make the video
  makeTitle: { id: 'app.sml.musicVideo.make.title', defaultMessage: 'Make the music video' },
  makeText: {
    id: 'app.sml.musicVideo.make.text',
    defaultMessage:
      'We make the file from cut {number} on our servers. You can close the editor; we tell you when it is ready.',
  },
  factLength: { id: 'app.sml.musicVideo.make.factLength', defaultMessage: 'Length' },
  factLengthFull: { id: 'app.sml.musicVideo.make.factLengthFull', defaultMessage: '{length} · full song' },
  factSize: { id: 'app.sml.musicVideo.make.factSize', defaultMessage: 'Size' },
  factSizeValue: { id: 'app.sml.musicVideo.make.factSizeValue', defaultMessage: '{width} × {height} · MP4' },
  factCost: { id: 'app.sml.musicVideo.make.factCost', defaultMessage: 'Costs' },
  factCostValue: {
    id: 'app.sml.musicVideo.make.factCostValue',
    defaultMessage: '{credits, plural, one {# credit} other {# credits}} · {before} → {after}',
  },
  factCostPlain: {
    id: 'app.sml.musicVideo.make.factCostPlain',
    defaultMessage: '{credits, plural, one {# credit} other {# credits}}',
  },
  replaceUpload: {
    id: 'app.sml.musicVideo.make.replaceUpload',
    defaultMessage:
      'The song already has a music video (your file). The new one <b>replaces it in the Kit</b>. Your file stays in Your clips.',
  },
  replaceYouTube: {
    id: 'app.sml.musicVideo.make.replaceYouTube',
    defaultMessage:
      'The song already has a music video (a YouTube link). The new one <b>replaces it in the Kit</b>. The video stays on YouTube.',
  },
  makeConfirm: {
    id: 'app.sml.musicVideo.make.confirm',
    defaultMessage: 'Make it · {credits, plural, one {# credit} other {# credits}}',
  },
  makeErrorFootageGone: {
    id: 'app.sml.musicVideo.make.error.footageGone',
    defaultMessage: 'A clip of this cut was removed. Replace it, then try again.',
  },
  makeErrorFootageProcessing: {
    id: 'app.sml.musicVideo.make.error.footageProcessing',
    defaultMessage: 'We still prepare one of your clips. Try again in a few minutes.',
  },
  makeErrorReleases: {
    id: 'app.sml.musicVideo.make.error.releases',
    defaultMessage: 'Your plan has no free release slot for this song.',
  },
  makeErrorNoMaster: {
    id: 'app.sml.musicVideo.make.error.noMaster',
    defaultMessage: 'The song file is not ready yet. Try again when we read it.',
  },
  makeErrorDemo: { id: 'app.sml.musicVideo.make.error.demo', defaultMessage: 'The example artist is read only.' },
  makeErrorFailed: {
    id: 'app.sml.musicVideo.make.error.failed',
    defaultMessage: 'The video did not start. Try again.',
  },

  // e4: the plan gate
  proChip: { id: 'app.sml.musicVideo.pro.chip', defaultMessage: 'Pro' },
  proTitle: { id: 'app.sml.musicVideo.pro.title', defaultMessage: 'Full-song videos are on Pro' },
  proText: {
    id: 'app.sml.musicVideo.pro.text',
    defaultMessage:
      'Your cut is saved. On Pro you make it into a file for YouTube, with {credits} video credits a month. A music video uses {cost}.',
  },
  proKeep: { id: 'app.sml.musicVideo.pro.keep', defaultMessage: 'Keep editing' },
  proGo: { id: 'app.sml.musicVideo.pro.go', defaultMessage: 'Go Pro · {price} a month' },

  // e3: making
  making: {
    id: 'app.sml.musicVideo.making.progress',
    defaultMessage: 'Making the video · {percent}%. You can keep editing; it uses cut {number} as it was.',
  },
  makingQueued: {
    id: 'app.sml.musicVideo.making.queued',
    defaultMessage: 'Making the video. You can keep editing; it uses cut {number} as it was.',
  },
  makingReady: { id: 'app.sml.musicVideo.making.ready', defaultMessage: 'Your music video is ready.' },
  makingFailed: {
    id: 'app.sml.musicVideo.making.failed',
    defaultMessage: 'The video failed. Your {credits, plural, one {# credit is} other {# credits are}} back.',
  },
  goToKit: { id: 'app.sml.musicVideo.making.goToKit', defaultMessage: 'Go to the Kit' },
});
